import AwsS3Service from '../../services/AwsS3Service';
import SellerImageService from '../../services/SellerImageService';
import sellerImageUseCase from './sellerImageUseCase';

const sellerImageFactory = sellerImageUseCase({
  AwsS3Service: AwsS3Service(),
  SellerImageService: SellerImageService(),
});

export default sellerImageFactory;
